"use client";

import { useIsOptionHedged } from "#/store/options/tradePanel/isOptionHedged";

import { HedgeTradeButton } from "../HedgeTradeButton/HedgeTradeButton";
import { MarketTradeButton } from "../MarketTradeButton/MarketTradeButton";

interface TradeConfirmModalButtonProps {
  isTradeConfirmation: boolean;
  onSuccess: () => void;
}

export const TradeConfirmModalButton: React.FC<
  TradeConfirmModalButtonProps
> = ({ isTradeConfirmation, onSuccess }) => {
  const { isOptionHedged } = useIsOptionHedged();

  return isOptionHedged ? (
    <HedgeTradeButton
      isTradeConfirmation={isTradeConfirmation}
      onSuccess={onSuccess}
    />
  ) : (
    <MarketTradeButton
      isTradeConfirmation={isTradeConfirmation}
      onSuccess={onSuccess}
    />
  );
};
